import styles from './PlacingOrderListItem.module.scss';
import Avatar from '@components/Avatar';
import cn from 'classnames';
import InfoIcon from '@assets/icons/info-grey-18.svg';
import {
  EPlacingOrderListItemCol,
  IPlacingOrderListItemProps,
  TPlacingOrderListItemCol
} from '../../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';
import { Tooltip } from '@components/new/Tooltip';
import { useState } from 'react';

const PlacingOrderListItem: React.FC<IPlacingOrderListItemProps> = (props: IPlacingOrderListItemProps): React.ReactElement => {
  const { cols } = props;

  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  return (
      <li
          className={cn(styles.item,
              cols.length === 2 && styles.itemDouble,
              cols.length === 3 && styles.itemTriple
          )}
          onMouseLeave={() => setIsTooltipVisible(false)}
      >
        {cols.map((item: TPlacingOrderListItemCol, index: number) => {
              if (item.type === EPlacingOrderListItemCol.AVATAR) {
                return (
                    <span
                        className={styles.itemCol}
                        key={index}
                    >
                      <div className={styles.description}>
                        <Avatar
                            name={item.title}
                            type="small"
                        />
                        <Text
                            color={TextColor.DARK_MUTED}
                            size={TextSize.M}
                        >
                          {item.title}
                        </Text>
                      </div>
                    </span>
                );
              }
              if (item.type === EPlacingOrderListItemCol.DEFAULT) {
                return (
                    <span
                        className={styles.itemCol}
                        key={index}
                    >
                      <Text
                          color={TextColor.PRIMARY}
                          size={TextSize.S}
                          weight={index ? TextWeight.NORMAL : TextWeight.BOLD}
                      >
                        {item.title}
                      </Text>
                      {item.value && (
                          <Text
                              color={TextColor.DARK_MUTED}
                              size={TextSize.XS}
                          >
                            {item.value}
                          </Text>
                      )}
                    </span>
                );
              }
              if (item.type === EPlacingOrderListItemCol.TRACKING_NUMBER) {
                return (
                    <span
                        className={styles.itemCol}
                        key={index}
                    >
                      <Text
                          color={TextColor.PRIMARY}
                          size={TextSize.S}
                          weight={index ? TextWeight.NORMAL : TextWeight.BOLD}
                      >
                        {item.title}
                      </Text>
                      {(item.value && (item.value !== item.title)) && (
                          <Text
                              color={TextColor.DARK_MUTED}
                              size={TextSize.XS}
                          >
                            {item.value}
                          </Text>
                      )}
                    </span>
                );
              }
              if (item.type === EPlacingOrderListItemCol.LINK) {
                return (
                    <span
                        className={styles.itemCol}
                        key={index}
                    >
                      <a
                          className={styles.link}
                          href={item.value}
                          rel="noreferrer"
                          target="_blank"
                      >
                        {item.title}
                      </a>
                    </span>
                );
              }
              if (item.type === EPlacingOrderListItemCol.WARNING) {
                return (
                    <span
                        className={styles.itemCol}
                        key={index}
                    >
                      <div className={styles.description}>
                        {item.tooltip ? (
                            item.withIcon ? (
                                <>
                                  {item.infoOnly ? (
                                      <span className={styles.itemCol}>
                                        <Text
                                            color={TextColor.PRIMARY}
                                            size={TextSize.S}
                                        >
                                          {item.title}
                                        </Text>
                                        {item.value && (
                                            <Text
                                                color={TextColor.DARK_MUTED}
                                                size={TextSize.XS}
                                            >
                                              {item.value}
                                            </Text>
                                        )}
                                      </span>
                                  ) : (
                                      <Text
                                          color={TextColor.WARM_PINK}
                                          size={TextSize.S}
                                      >
                                        {item.title}
                                      </Text>
                                  )}
                                  {item.actionHover ? (
                                      <div className={styles.actionHover}>
                                        <img
                                            alt="Info"
                                            onMouseEnter={() => setIsTooltipVisible(true)}
                                            src={InfoIcon}
                                        />
                                        {isTooltipVisible && (
                                            <div className={styles.tooltip}>
                                              {item.actionHover}
                                            </div>
                                        )}
                                      </div>
                                  ) : (
                                      <Tooltip
                                          action={
                                            <img
                                                alt="Info"
                                                src={InfoIcon}
                                            />
                                          }
                                          position="top"
                                          text={item.tooltip}
                                          whiteSpace="pre-wrap"
                                      />
                                  )}
                                </>
                            ) : (
                                <Tooltip
                                    action={
                                      <Text
                                          color={TextColor.WARM_PINK}
                                          size={TextSize.S}
                                      >
                                        {item.title}
                                      </Text>
                                    }
                                    position="left"
                                    text={item.tooltip}
                                    whiteSpace="pre-wrap"
                                />
                            )
                        ) : (
                            <>
                              <Text
                                  color={TextColor.WARM_PINK}
                                  size={TextSize.S}
                              >
                                {item.title}
                              </Text>
                              <span className={styles.descriptionPlug}/>
                            </>
                        )}
                      </div>
                    </span>
                );
              }
            }
        )}
      </li>
  );
};

export default PlacingOrderListItem;
